module.exports = __webpack_public_path__ + "2677b34956ef1b279203e6f026db06ca.pdf";